import { BaseType } from '../base/base-type';
import { FundTypeIdEnum } from '../enum/shared/fund-type-id.enum';

export class FundType extends BaseType {
  public declare id: FundTypeIdEnum;
  public colour!: string;

  public isCash(): boolean {
    return this.id === FundTypeIdEnum.Cash;
  }

  public isBalanced(): boolean {
    return this.id === FundTypeIdEnum.Balanced;
  }

  public getChartDataColor(): string {
    return this.colour ?? '#DC3725';
  }
}
